import React, { useState, useEffect } from 'react'
import { logsDetailsApiCommunityByUserId,logsTotalCountApi } from './CommActionCreator'
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import Loader from '../../../../../../../presentationals/Loader/Loader.component';
import Pagination from '../../../TablePagination'

const LogsDetails = ({rowData}) => {
    const [logsData, setlogsData] = useState('')
    const location = useLocation();
    const [loader, setloader] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [noOfRows, setNoOfRows] = useState(10)
    const paginationHandler = (pageNo, rows) => {
        console.log(pageNo,rows)
        setPageNumber(pageNo)
        setNoOfRows(rows)
        logsDataApi(pageNo,rows)
    }
    const getCountHandler = () => {
        logsTotalCountApi(rowData,callBack => {
            console.log(callBack)
            setTotalCount(callBack.data)
        }, error => {

        })
    }
    useEffect(() => {
        window.scrollTo(250, 110);
        logsDataApi(pageNumber,noOfRows)
    }, [])
    const logsDataApi = (page,rows) => {
        setloader(true)
        logsDetailsApiCommunityByUserId(page,rows, rowData, callBack => {
            setlogsData(callBack)
            getCountHandler()
            setloader(false)

        }, error => {

        })
    }
    return (
        <div className='container-fluid full-height'>
            {loader ?
                <Loader />
                : ""}
            <div className='row mt-3'>

                <div style={{ overflowX: 'auto' }}>
                    <table className='table credhub-table'>
                        <thead>
                            <tr>
                                <th scope="col">Date</th>

                                <th scope="col">EmailId</th>
                                <th scope="col">From</th>

                                <th scope="col">Reciever Type</th>
                                <th scope="col">Sender Type</th>
                                <th scope="col">Body</th>


                            </tr>
                        </thead>
                        <tbody>
                            {logsData && logsData.map((row, i) => {
                                return (
                                    <tr key={i}>

                                        <td>{row.date}</td>
                                        <td>{row.emailId}</td>
                                        <td>{row.fromAddress}</td>
                                        <td>{row.recieverType}</td>
                                        <td>{row.senderType}</td>

                                        <td style={{ whiteSpace: 'break-spaces' }}>
                                            <Tooltip
                                                style={{ fontSize: '14px' }}
                                                title={[row.body]}
                                                placement='bottom'
                                                arrow
                                            >
                                                <p
                                                    className='multi-line-ellipsis'>
                                                    {row.body.slice(0, 15) + (row.body.length > 15 ? "..." : "")}
                                                </p>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <Pagination
                        totalCount={totalCount}
                        paginationHandler={paginationHandler}
                        pageNumber={pageNumber}
                        noOfRows={noOfRows}
                    />
            </div>
        </div>
    )
}

export default LogsDetails;